import generalStrings from './strings';

export const registerFormStepsEnum = {
  businessIndustry: 1,
  companyInformation: 2,
  userPosition: 3,
  accountInformation: 4,
  confirmation: 5,
  error: 6,
};

export const registerFormTitleToStepMapEnum = {
  [registerFormStepsEnum.businessIndustry]: generalStrings.registerForm.businessIndustryTitle,
  [registerFormStepsEnum.companyInformation]: generalStrings.registerForm.companyInformationTitle,
  [registerFormStepsEnum.userPosition]: generalStrings.registerForm.userPositionTitle,
  [registerFormStepsEnum.accountInformation]: generalStrings.registerForm.accountInformationTitle,
};

export const registerFormSubTitleToStepMapEnum = {
  [registerFormStepsEnum.businessIndustry]: generalStrings.registerForm.businessIndustrySubTitle,
  [registerFormStepsEnum.companyInformation]:
    generalStrings.registerForm.companyInformationSubTitle,
  [registerFormStepsEnum.userPosition]: generalStrings.registerForm.userPositionSubTitle,
  [registerFormStepsEnum.accountInformation]:
    generalStrings.registerForm.accountInformationSubTitle,
};

export const registerFormValidationErrorType = {
  valid: 1,
  empty: 2,
  wrong: 3,
};
